/* eslint-disable max-len */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* global window */
import React from 'react';
import { connect } from 'react-redux';
import { withTranslate } from 'react-redux-multilingual';
import { requestQuotes } from 'Actions/QuotesActions';
import { requestXrefByVenueXids } from 'Actions/xrefActions';
import { requestMarketsOverviewChart } from 'Actions/MarketsOverviewActions';
import ChangeDir from 'components/ChangeDir/ChangeDir';
import HiddenTable from 'components/HiddenTable/HiddenTable';
import './QuoteCardList.scss';
import { requestMultiplePriceChart } from '../../Actions/PriceChartActions';

import upArrow from '../../assets/images/upArrow.png';
import downArrow from '../../assets/images/downArrow.png';

const mapStateToProps = state => ({
	quoteData: state.quotesData.quotesByXid,
	fetchingQuoteData: state.quotesData.data.fetchingQuoteData,
	marketsOverviewChartData: state.marketsOverviewChartData,
	priceChartData: state.priceChartData.data,
	locale: state.Intl.locale
});

const mapDispatchToProps = dispatch => ({
	getQuotes: xids => dispatch(requestQuotes(xids)),
	getXref: xids => dispatch(requestXrefByVenueXids(xids)),
	getMoChart: () => dispatch(requestMarketsOverviewChart()),
	getPriceChart: (xids, isMutualFund) => dispatch(
		requestMultiplePriceChart(1, xids, 1, 1, false, isMutualFund, false, 'en')
	)
});

class QuoteCardList extends React.Component {
	constructor(props) {
		super(props);

		this.getPriceChartData = this.getPriceChartData.bind(this);
		this.getQuoteData = this.getQuoteData.bind(this);
	}

	componentDidMount() {
		const {
			symbols,
			getXref
		} = this.props;
		if (symbols && symbols.length > 0) {
			const xids = symbols.map(symbol => symbol.xid);
			this.getQuoteData(xids);
			getXref(xids);
			this.getChartsData();
			this.getPriceChartData(xids);
		}
	}

	getQuoteData = XidsArray => {
		const { getQuotes } = this.props;
		if (XidsArray && XidsArray.length) {
			getQuotes(XidsArray);
		}
	}

	getChartsData() {
		const { getMoChart } = this.props;
		getMoChart();
	}

	getPriceChartData = xids => {
		const {
			getPriceChart
		} = this.props;

		if (xids) {
			xids.forEach(xid => {
				getPriceChart(xid, false);
			});
		}
	}

	RenderQuoteCard(symbolInfo, index) {
		const { quoteData, isCommodities, marketsOverviewChartData, priceChartData, translate } = this.props;
		const { xid, name, hiddenName } = symbolInfo;
		const { format } = window;
		const { lastTrade, changePercent } = quoteData[xid] || {};
		const { last, change } = lastTrade || {};
		const { today } = changePercent || {};
		const { marketsOverviewChartData: imgData } = marketsOverviewChartData || {};
		const { image } = imgData[xid] || {};
		const { hoverData } = priceChartData[xid] || {};

		const hiddenTable = hoverData ? (
			<HiddenTable
				settings={[
					{
						label: translate('date'),
						formatFunc: 'monthDayYearLong',
						isMsDate: true,
						dataPoint: 'Date'
					},
					{
						label: translate('value'),
						formatFunc: 'price',
						dataPoint: 'Value'
					}
				]}
				tableData={hoverData}
				caption={`${name} chart values`} />
		) : null;

		let arrowDisplay;
		if (today > 0) {
			arrowDisplay = (
				<img
					className="arrow"
					src={upArrow}
					alt="up arrow" />
			);
		} else if (today < 0) {
			arrowDisplay = <img className="arrow" src={downArrow} alt="down arrow" />;
		} else {
			arrowDisplay = <span className="dash">{'\u2014'}</span>;
		}
		const pricePercentColor = `price-percent ${format.getColorClass(today)}`;
		return (
			<div
				key={`quote-card-${index}`}
				className="quote-card"
				id={`quote-card-${index}`}>
				<div className="symbol">
					{name}
					{' '}
					{arrowDisplay}
				</div>
				<span className="sr-only">{hiddenName}</span>

				<div style={{ display: 'flex' }}>
					<div className="quote-value-percent-container">
						<div className="lastValue">
							{isCommodities ? format.priceNoSign(last, 2) : format.numberNoSign(last)}
						</div>
						<div className={pricePercentColor}>
							<ChangeDir value={change} />
							{format.numberWithSign(change)}
							<span className="percentChange" style={{ paddingLeft: '2px' }}>
								<ChangeDir value={today} />
								{`(${format.percentWithSign(today)})`}
							</span>
						</div>
					</div>
					<div className="quote-chart-img-container">
						<a style={{ cursor: 'default' }}>
							<img className="chartImg" src={image} alt="Change Chart" />
						</a>
					</div>
				</div>
				<a className="hiddenTable" href={`.quote-card-${index + 1}`}>
					<div id="hiddenTable">
						{hiddenTable}
					</div>
				</a>

			</div>
		);
	}

	RenderQuoteCardList() {
		const { symbols, id, translate, quoteData, locale } = this.props;
		const { format } = window;
		const delayedCopy = translate('marketsOverviewDelayedBy15');

		// symbols[0] = TSX and We are avoiding it for now since timestamp from provider is wrong. See CIBC-7572.
		let asOfDate = null;
		if (quoteData
			&& symbols.length > 1
			&& symbols[1].xid
			&& quoteData[symbols[1].xid]
			&& quoteData[symbols[1].xid].lastTrade) {
			asOfDate = quoteData[symbols[1].xid].lastTrade.date;
		}

		const QuoteCards = [];
		for (let Index = 0; Index < symbols.length; Index += 1) {
			QuoteCards.push(this.RenderQuoteCard(symbols[Index], Index));
		}

		return (
			<div className="quote-card-container" style={{ display: 'flex', flexDirection: 'column' }}>
				<div style={{ display: 'flex' }}>
					<div style={{ flexGrow: 1 }}>
						<span className="asOf">
							{`${translate('dailyMarketAsOf')} ${format.monthDayYearTime(asOfDate) || ''}. ${delayedCopy}`}
						</span>
					</div>
					<div>
						<span className={locale === 'fr' ? 'marketOverviewLinkFR' : 'marketOverviewLinkEN'}>
							<a
								role="link"
								tabIndex="0"
								onKeyDown={event => {
									if (event.keyCode === 13) {
										window.mdPageActions.navigateOBR('market-overview');
									}
								}}
								onClick={() => {
									window.mdPageActions.navigateOBR('market-overview');
								}}>
								{translate('marketOverview')}
							</a>
						</span>
					</div>
				</div>
				<div id={id} className="new-quote-card-list">
					{QuoteCards}
				</div>
			</div>
		);
	}

	render() {
		return (
			<div>
				{this.RenderQuoteCardList()}
			</div>
		);
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(QuoteCardList));
